import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのNotificationロゴアイコン
 */
export function ProductLogoMediumNotification({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.95238" fill="#1A2142" />
      <path
        d="M19.9994 32.1429C21.9719 32.1429 23.5709 30.5439 23.5709 28.5715H16.428C16.428 30.5439 18.027 32.1429 19.9994 32.1429Z"
        fill="#57D7D9"
      />
      <path
        d="M9.28516 25.7143C9.28516 24.9253 9.92475 24.2857 10.7137 24.2857H29.2852C30.0741 24.2857 30.7137 24.9253 30.7137 25.7143C30.7137 26.5033 30.0741 27.1429 29.2852 27.1429H10.7137C9.92475 27.1429 9.28516 26.5033 9.28516 25.7143Z"
        fill="#FCFCFD"
      />
      <path
        d="M12.1423 17.1429C12.1423 13.198 15.3403 10 19.2852 10H20.7137C24.6586 10 27.8566 13.198 27.8566 17.1429V25.7143H12.1423V17.1429Z"
        fill="#FCFCFD"
      />
      <path
        d="M18.2137 9.64289C18.2137 8.65667 19.0132 7.85718 19.9994 7.85718C20.9857 7.85718 21.7852 8.65667 21.7852 9.64289V11.4286H18.2137V9.64289Z"
        fill="#FCFCFD"
      />
    </svg>
  );
}
